import { PAGE_TYPES } from '@dashboard/enums/page-types';

export function getPageCurrency(page = {}) {
  if (page.type === PAGE_TYPES.CHECKOUT) {
    // TODO(M14): reads legacy product scalars — repoint to prices[]/selected price before legacy fields are removed (product.currency)
    return page.product?.currency;
  }

  if (page.type === PAGE_TYPES.EVENT) {
    return page.eventDetails?.currency;
  }

  return 'USD';
}
